<template>
    <div>
      <b-overlay :show="showoverlay">
        <div class="users-style">
          
        <h4 class="mt-3 mb-2">Leave Past Data</h4>
        <p style="font-size: 15px;">Download the template, insert the data in the sheet and import the historical data.</p>
          <div class="d-flex align-items-center justify-content-between flex-wrap py-2 mb-2">

            <div class="custom-search mb-2 mb-md-0 w-100">
              <b-input-group class="mb-0">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
              </b-input-group>
            </div>

            <div class="d-flex align-items-center">
              <div class="mr-2">
                <b-form-select id="year" name="year" v-model="year" :options="years" @change="getLeaves"></b-form-select>
              </div>

              <b-button class="mr-2" @click="downloadTemplate">
                <b-icon icon="code-slash"></b-icon> Template
              </b-button>

              <b-button @click="openModal">
                <b-icon icon="box-arrow-up" scale="1"></b-icon> Import
              </b-button>
            </div>

          </div>

          <div class="row justify-content-center no-margin">
            <div class="col-sm-12  px-0">
              <table class="table dataTable">
                <thead>
                <tr class="table-head">
                  <td class="cursor-pointer" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"><span>{{column.label}}</span></td>
                  <td class="text-right" v-if="ce">Action</td>
                </tr>
                </thead>
                <tbody>
                <template v-for="(leave , n) in paginatedData">
                  <tr class="table-row hover-bg">
                    <td class=" ">
                      <div class="img-holder">
                        <img v-bind:src="'/avatar/'+ leave.company_id + '/' + leave.employee_pic" class="img-fluid img-thumbnail employee-avatar mr-2" />
                      </div>
                      <div class="name-holder">
                        {{leave.employee_name}}<br />
                        <span class="txt-alt">{{leave.employee_code}}</span>
                      </div>
                    </td>
                    <td class="">{{leave.jobposition}}</td>
                    <td class="">{{leave.department}}</td>
                    <td class="">{{leave.leave_type}}</td>
                    <td class="">{{leave.from}}</td>
                    <td class="">{{ leave.to }}</td>
                    <td class="">{{leave.number_of_days}} day<span v-if="leave.number_of_days > 1">s</span></td>
                    <td class="">{{leave.reason}}</td>
                    <td class="">
                      <span class="leave-status" v-if="leave.status == 'Approved'"><i class="far fa-dot-circle mr-1 text-success"></i>{{leave.status}}</span>
                      <span class="leave-status" v-else-if="leave.status == 'Applied'"><i class="far fa-dot-circle mr-1 text-primary"></i>Applied</span>
                      <span class="leave-status" v-else-if="leave.status == 'Declined'"><i class="far fa-dot-circle mr-1 text-danger"></i>{{leave.status}}</span>
                    </td>

                    <td class="">{{leave.updated_by}}</td>

                    <td class="position-relative text-right" v-if="ce">
                      <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                      <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                        <b-button-group class="mr-0">
                          <b-button class="rounded delete-btn" title="Delete Work Location" @click="deleteLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)">
                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                          </b-button>
                        </b-button-group>
                      </div>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>


              <div v-if="paginatedData.length == 0" class="list-no-data">No records found.</div>
              <div v-else class="px-3 mt-4">
                <ul class="pagination b-pagination float-left mb-0 mt-1">
                  <li class="page-item disabled m-2">View</li>
                  <li class="page-item disabled">
                    <b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select>
                  </li>
                  <li class="page-item disabled m-2">per page. Total {{leaves.length}} records found.</li>
                </ul>
                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
      <b-modal id="bv-leave-history" size="md" hide-footer title="Upload Consumed Leaves On Current Leave Year Here" >
        <div class="row clearfix mb-2"><div class="col-md-12">Click browse and upload file</div></div>
        <b-form-file id="datafile" name="datafile" @change="checkFileType($event , 'datafile', ['.xls', '.xlsx'])" v-model="selectedFile" browse-text="Browse" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @input="onFileChange"
                     accept=".xlsx,.xls"></b-form-file>
        <div class="d-flex justify-content-center align-items-center mt-3">
          <b-button variant="secondary" class="mr-2" @click="closeModal">Cancel</b-button>
          <b-button variant="primary" :disabled="!selectedFile" @click="importFile">Import</b-button>
        </div>
      </b-modal>
    </div>
</template>
<script>
    export default{
        mounted() {
            if(this.check_ce == 1)
            {
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;

            }
        },
        props: [ 'flg'],
        components: {},
        data(){
            const now = new Date()
            let sortOrders = {};
            let columns = [
                            {label: 'Employee', name: 'employee_name' },
                            {label: 'Job Position', name: 'employee_code' },
                            {label: 'Department', name: 'department' },
                            {label: 'Leave Category', name: 'leave_type'},
                            {label: 'From', name: 'from'},
                            {label: 'To', name: 'to'},
                            {label: 'No. of Days', name: 'number_of_days'},
                            {label: 'Reason', name: 'reason'},
                            {label: 'Status', name: 'status'},
                            {label: 'Updated By', name: 'updated_by'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});


            return {

                search_by_id:{department_id:0, leave_type_id:0 , flg_status:0},
                year :  now.getFullYear(),
                years: [{ text: now.getFullYear()-1, value: now.getFullYear()-1 },{ text: now.getFullYear(), value: now.getFullYear() }],
                flg_status : [
                            { text: 'Applied', value: '0' },
                            { text: 'Approved', value: '1' },
                            { text: 'Declined', value: '2' },
                        ],

                columns: columns,
                sortKey: 'employee_name',
                sortOrders: sortOrders,

                leaves:[],

                showoverlay:false,

                search:'',
                length: 20,
                temp_length: 20,
                length_options: [
                  { value: 20, text: "20" },
                  { value: 50, text: "50" },
                  { value: 100, text: "100" },
                  { value: 500, text: "500" },
                  { value: 1500, text: "1500" },
                ],
                pagination: {currentPage: 1, pages:1},

                ce:true,
              selectedFile: false,
            }
        },
        methods:{
          downloadTemplate(){
            if (!this.checkNet()) return;
            this.showoverlay = true;
            axios.get(this.$api_url + '/leave-attendance/leave/template', {params:{f:1},responseType: 'blob'}).then(response => {
              this.global_download_file_content(response);
              this.showoverlay = false;
            }).catch(e => this.serverError(e));
          },
          openModal() {
            this.$bvModal.show('bv-leave-history');
            this.selectedFile = null
          },

          closeModal() {
            this.$bvModal.hide('bv-leave-history');
            this.selectedFile = null
          },

          onFileChange(event) {
            this.selectedFile = event;
          },

          importFile() {
            if (!this.selectedFile) return;

            this.$bvToast.toast('You leave data is importing.', {
              title: 'Hang Tight!',
              variant: 'success',
              solid: true,
            })

            let formData = new FormData();
            const config = {
              headers: { 'content-type': 'multipart/form-data' }
            }
            this.showoverlay = true;
            formData.append('template', this.selectedFile);
            axios.post(this.$api_url + '/leave-attendance/leave/import', formData, config).then(response => {
              if(response.data.errors) {
                this.errors = response.data.errors;
              }
              else {
                this.errors = [];
                this.$bvToast.toast(response.data.message,{
                  solid: true,
                  title: 'Success',
                  variant: 'success'
                });
                this.getLeaves();
                this.showoverlay = false;
                this.closeModal();
              }
            }).catch(e => {
              this.serverError(e);
              this.showoverlay = false;
              this.closeModal();
            });

          },


          getLeaves: function() {
                this.showoverlay = true;
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/leave-attendance/employee/leaves/fiscalyear' , {
                    params: {
                      year:this.year,
                    }
                }).then((response) => {
                  this.showoverlay = false;
                  this.leaves = response.data.leaves;
                }).catch((error) => {
                  this.serverError(error);
                });
            },


            deleteLeave: function(employee_id , leave_type_id , flg_status , from , to) {
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                formData.append('leave_type_id' , leave_type_id);
                formData.append('from' , from);
                formData.append('to' , to);
                formData.append('flg_status' , flg_status);

                axios.post(this.$api_url+'/leave-attendance/leave/delete/range', formData).then((response) => {
                  this.$bvToast.toast('Deleted!', {
                      title: `Success`,
                      variant: 'success',
                      solid: true
                  });
                  this.getLeaves();
                }).catch((error) => {
                    this.showoverlay = false;
                    this.serverError(error);
                });
            },

            setFirstPage() {
              this.pagination.currentPage = 1;
              this.length = this.temp_length;
            },
        },
        created: function(){
            this.getLeaves();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.leaves;
                if (this.search)
                {

                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                        a = String(a[sortKey]).toLowerCase();
                        b = String(b[sortKey]).toLowerCase();
                        if (this.columns[index].type && this.columns[index].type === 'date')
                        {
                            return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                        }
                        else if (this.columns[index].type && this.columns[index].type === 'number')
                        {
                            return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                        }
                        else
                        {
                            return (a === b ? 0 : a > b ? 1 : -1) * order;
                        }
                    }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            fetchStartWeekday()
            {
                return this.week_start_day;
            },
        }
    }
</script>
